module.exports = __webpack_public_path__ + "fonts/pts.d7dd99e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pts.eot?1k5nh7
// module id = 278
// module chunks = 0